import styled from 'vue3-styled-components';
import { injectGlobal } from 'vue3-styled-components';

injectGlobal`
    table, th, td {
        border-collapse: collapse;
    }
    body.swal2-toast-shown .swal2-container.swal2-top {
        top:50px;
    }
    .flex-div{
        width: 100%;
        display: flex;
        align-items: center;
    }
`;

export const FlexDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const FontBold = styled.div`
    font-weight: bold;
    padding-top: 10px;
`;

export const HanqBtn = FontBold.extend`
    box-shadow: 0 8px 9px -4px rgba(175, 156, 156, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    padding: 7px;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
`;